import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PrivacyPolicy } from "../../../PrivacyPolicy";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <PrivacyPolicy />
  </StrictMode>
);

(import.meta.hot.data.root ??= createRoot(elem)).render(app);
